export const assessmentTemplate = [
  {
    _id: "phq8",
    omniAudit: {
      auditVersion: "1",
      omniRevision: "1",
      omniSchema: "assessmentTemplate",
      omniSchemaVersion: "1",
      writtenBy: null,
      createdBy: "Mmigliuri",
      createdDate: "2022-03-010T00:00:00Z",
      modifiedBy: null,
      modifiedDate: null,
      isActive: true,
    },
    omniData: {
      omniType: "phq8",
      omniTypeVersion: 1,
      title: "Personal Health Questionnaire Depression Scale (PHQ-8)",
      purpose: "Depression Scale",
      description:
        "The eight-item Patient Health Questionnaire depression scale (PHQ-8) is established as a valid diagnostic and severity measure for depressive disorders in large clinical studies. Our objectives were to assess the PHQ-8 as a depression measure in a large, epidemiological population-based study, and to determine the comparability of depression as defined by the PHQ-8 diagnostic algorithm vs. a PHQ-8 cutpoint > or = 10.",
      duration: "About 20 minutes",
      directions:
        "Over the <b>last 2 weeks</b>, how often have you been bothered by any of the following problems? Select one option for each question)",
      attribution:
        "This scale is free to use without permission. Self-Management Resource Center, www.selfmanagementresource.com",
      validated: "true",
      selfAssessment: false,
      startDate: null,
      completeDate: null,
      questions: [
        {
          omniID: "PHQ81",
          numberText: "1",
          text: "How often during the past 2 weeks were you bothered by little interest or pleaure in doing things?",
          subText: "",
          helpText: "",
          displayType: "button",
          multiSelectText: "false",
          instructions: "Please select the answer that most closely applies",
          answerOptions: [
            {
              value: "0",
              text: "Not at all",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "1",
              text: "Several days",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "2",
              text: "More than half the days",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "3",
              text: "Nearly every day",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "PHQ82",
          numberText: "2",
          text: "How often during the past 2 weeks were you bothered by feeling down, depressed, or hopeless?",
          subText: "",
          helpText: "",
          displayType: "button",
          multiSelectText: "false",
          instructions: "Please select the answer that most closely applies",
          answerOptions: [
            {
              value: "0",
              text: "Not at all",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "1",
              text: "Several days",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "2",
              text: "More than half the days",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "3",
              text: "Nearly every day",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "PHQ83",
          numberText: "3",
          text: "How often during the past 2 weeks were you bothered by trouble falling or staying asleep, or sleeping too much?",
          subText: "",
          helpText: "",
          displayType: "button",
          multiSelectText: "false",
          instructions: "Please select the answer that most closely applies",
          answerOptions: [
            {
              value: "0",
              text: "Not at all",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "1",
              text: "Several days",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "2",
              text: "More than half the days",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "3",
              text: "Nearly every day",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "PHQ84",
          numberText: "4",
          text: "How often during the past 2 weeks were you bothered by feeling tired or having little energy?",
          subText: "",
          helpText: "",
          displayType: "button",
          multiSelectText: "false",
          instructions: "Please select the answer that most closely applies",
          answerOptions: [
            {
              value: "0",
              text: "Not at all",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "1",
              text: "Several days",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "2",
              text: "More than half the days",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "3",
              text: "Nearly every day",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "PHQ85",
          numberText: "5",
          text: "How often during the past 2 weeks were you bothered by poor appetite or overeating?",
          subText: "",
          helpText: "",
          displayType: "button",
          multiSelectText: "false",
          instructions: "Please select the answer that most closely applies",
          answerOptions: [
            {
              value: "0",
              text: "Not at all",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "1",
              text: "Several days",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "2",
              text: "More than half the days",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "3",
              text: "Nearly every day",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "PHQ86",
          numberText: "6",
          text: "How often during the past 2 weeks were you bothered by feeling bad about yourself, or that you are failure, or have let yourself or your family down?",
          subText: "",
          helpText: "",
          displayType: "button",
          multiSelectText: "false",
          instructions: "Please select the answer that most closely applies",
          answerOptions: [
            {
              value: "0",
              text: "Not at all",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "1",
              text: "Several days",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "2",
              text: "More than half the days",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "3",
              text: "Nearly every day",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "PHQ87",
          numberText: "7",
          text: "How often during the past 2 weeks were you bothered by trouble concentrating on things, such as reading the newspaper or watching television?",
          subText: "",
          helpText: "",
          displayType: "button",
          multiSelectText: "false",
          instructions: "Please select the answer that most closely applies",
          answerOptions: [
            {
              value: "0",
              text: "Not at all",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "1",
              text: "Several days",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "2",
              text: "More than half the days",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "3",
              text: "Nearly every day",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "PHQ88",
          numberText: "8",
          text: "How often during the past 2 weeks were you bothered by moving or speaking so slowly that other people could have noticed? Or the opposite - being so fidgety or restless that you have been moving around a lot more than usual?",
          subText: "",
          helpText: "",
          displayType: "button",
          multiSelectText: "false",
          instructions: "Please select the answer that most closely applies",
          answerOptions: [
            {
              value: "0",
              text: "Not at all",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: true,
            },
            {
              value: "1",
              text: "Several days",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: true,
            },
            {
              value: "2",
              text: "More than half the days",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: true,
            },
            {
              value: "3",
              text: "Nearly every day",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: true,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
      ],
      assessmentResults: {
        finalResult: null,
      },
    },
  },
];

export const assessmentScoring = [
  {
    typeID: "phq8",
    algorithms: [
      {
        name: "sum",
        minScore: 0,
        maxScore: 15,
        formula: null,
        questions: [],
      },
    ],
  },
];
